/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIStoragePosition
 */
export interface APIStoragePosition {
    /**
     * 
     * @type {string}
     * @memberof APIStoragePosition
     */
    readonly self: string;
    /**
     * 
     * @type {number}
     * @memberof APIStoragePosition
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof APIStoragePosition
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIStoragePosition
     */
    comment?: string;
}

/**
 * Check if a given object implements the APIStoragePosition interface.
 */
export function instanceOfAPIStoragePosition(value: object): value is APIStoragePosition {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIStoragePositionFromJSON(json: any): APIStoragePosition {
    return APIStoragePositionFromJSONTyped(json, false);
}

export function APIStoragePositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIStoragePosition {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'id': json['id'],
        'name': json['name'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function APIStoragePositionToJSON(value?: Omit<APIStoragePosition, 'self'|'id'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'comment': value['comment'],
    };
}

